
import Vue from 'vue';
import VueListboxMultiselect from '@banneredge/vue-listbox-multiselect';

const dataSet = ['Apples', 'Oranges', 'Grapes', 'Bananas', 'Pineapples', 'Mangoes'];

export default Vue.extend({
  name: 'NoSearch',
  components: {
    VueListboxMultiselect,
  },
  data() {
    return {
      selectedList: [] as any[],
    };
  },
  methods: {
    async search(query: string): Promise<any[]> {
      const ids = this.selectedList.map((x) => x.id);
      const subset = dataSet.filter((x) => !ids.includes(x));

      return subset.map((x: any) => ({
        id: x,
        value: x,
      }));
    },
  },
});
